export default __webpack_public_path__ + "static/media/fasad1.03be49b2.jpeg";